import * as React from 'react';
import { createLocators } from '@u1/locators';

import useStyles from './TabPanel.styles';

export interface ITabPanelProps {
  children: React.ReactNode;
  tabKey: string;
  active?: boolean;
}

export const tabPanelLocators = createLocators({
  name: 'TabPanel',
  componentLocators: ['tabPanelItem'],
});
const { locators } = tabPanelLocators();

const TabPanel: React.FC<ITabPanelProps> = ({ active, children, tabKey }) => {
  const classes = useStyles();

  return (
    <section
      role="tabpanel"
      aria-labelledby={`tablabel-id-${tabKey}`}
      id={`tabpanel-id-${tabKey}`}
      hidden={!active}
      className={classes.root}
      {...locators.tabPanelItem({ tabKey })}
    >
      {children}
    </section>
  );
};

export default TabPanel;
